<div class="flex flex-row justify-end">
  <div
    class="flex truncate pl-5"
    [ngClass]="{
      'text-r1': isError === true,
      'hover:text-m500 cursor-pointer': params.data.rowType === rowTypeMetric
    }"
    (click)="clickCellData($event)"
    >{{ formattedValue }}</div
  >
</div>
